import React, { useState } from "react";
import StudentsTable from "../components/tables/StudentsTable";
import StudentModal from "../components/forms/StudentModal";
import { PlusCircle } from "lucide-react";

const Students: React.FC = () => {
  const [isAddModalOpen, setIsAddModalOpen] = useState(false);

  return (
    <div className="p-6 min-h-screen bg-gradient-to-br from-gray-50 to-blue-50/30">
      <div className="flex justify-between items-center mb-8">
        <div>
          <h1 className="text-3xl font-bold text-gray-900">Students</h1>
          <p className="text-gray-600 mt-1">
            Manage student enrollment and records
          </p>
        </div>
        <button
          onClick={() => setIsAddModalOpen(true)}
          className="bg-gradient-to-r from-blue-500 to-blue-600 hover:from-blue-600 hover:to-blue-700 text-white px-6 py-3 rounded-xl flex items-center space-x-2 transition-all duration-200 shadow-lg hover:shadow-xl transform hover:-translate-y-1 border-0"
        >
          <PlusCircle className="h-5 w-5" />
          <span>Add New Student</span>
        </button>
      </div>

      <div className="bg-white/80 backdrop-blur-sm rounded-2xl p-1 shadow-2xl">
        <StudentsTable />
      </div>

      <StudentModal
        isOpen={isAddModalOpen}
        onClose={() => setIsAddModalOpen(false)}
      />
    </div>
  );
};

export default Students;
